import React, { useEffect } from 'react'

const ScrollToTop = () => {

    useEffect(() => {
        const backToTopButton = document.querySelector('.back-to-top');

        if (!backToTopButton) return;

        const handleScroll = () => {
            const scrollPosition = window.scrollY || document.documentElement.scrollTop;

            if (scrollPosition > 1000) {
                backToTopButton.style.display = "block";
            } else {
                backToTopButton.style.display = "none";
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const scrollToTop = () => {
        const duration = 2000;
        const startTime = performance.now();

        const initialScroll = window.scrollY || document.documentElement.scrollTop;

        const animateScroll = (currentTime) => {
            const timeElapsed = currentTime - startTime;
            const progress = Math.min(timeElapsed / duration, 1);

            const newScrollPos = initialScroll * (1 - progress);

            window.scrollTo(0, newScrollPos);

            if (progress < 1) {
                requestAnimationFrame(animateScroll);
            }
        };
        requestAnimationFrame(animateScroll);
    }

    return (
        <div className="back-to-top" onClick={scrollToTop}>
            <span className="back-top"><i className="fa fa-angle-up"></i></span>
        </div>
    )
}

export default ScrollToTop;